/*
 * pl-cart.js — progressive AJAX add-to-cart for Plushie.Land.
 *
 * Enhances any <form class="js-pl-add"> (e.g. product cards) to post to
 * /cart/add.js without a full page reload, then refreshes every
 * [data-pl-cart-count] badge. With JavaScript disabled — or on any network
 * error — the browser falls back to the standard form submission, so the
 * store keeps working. Respects prefers-reduced-motion via CSS only.
 */
(function () {
  if (!window.fetch || !window.FormData) return;

  var ADDED_CLASS = 'is-added';

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-pl-cart-count]');
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = cart.item_count;
          badges[i].hidden = cart.item_count === 0;
        }
        document.dispatchEvent(new CustomEvent('pl:cart:updated', { detail: cart }));
        return cart;
      });
  }

  // Other sections (e.g. the product page) can ask the header badge to resync
  // after their own AJAX add by dispatching `pl:cart:refresh`.
  document.addEventListener('pl:cart:refresh', function () {
    refreshCartCount();
  });

  // Cart button: open the drawer (built separately) when present; otherwise
  // let the browser follow the link to the /cart page.
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest ? event.target.closest('[data-pl-cart-toggle]') : null;
    if (!toggle) return;
    if (document.querySelector('[data-pl-cart-drawer]')) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('pl:cart:open'));
    }
  });

  // Quick-add link on product cards: AJAX-add the given variant; on any error
  // fall back to navigating to the product page (the link's href).
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a.js-pl-quickadd') : null;
    if (!link) return;

    var variantId = link.getAttribute('data-variant-id');
    if (!variantId) return; // No variant → follow the link to the product page.

    event.preventDefault();
    if (link.classList.contains('is-loading')) return;
    link.classList.add('is-loading');

    var addUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        link.classList.add('is-added');
        var previousLabel = link.getAttribute('aria-label');
        var addedLabel = link.getAttribute('data-added-label');
        if (addedLabel) link.setAttribute('aria-label', addedLabel);
        window.setTimeout(function () {
          link.classList.remove('is-added');
          if (previousLabel) link.setAttribute('aria-label', previousLabel);
        }, 1200);
      })
      .catch(function () {
        window.location.href = link.href;
      })
      .finally(function () {
        link.classList.remove('is-loading');
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('form.js-pl-add') : null;
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var addUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    if (button) button.disabled = true;

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        if (button) {
          button.classList.add(ADDED_CLASS);
          window.setTimeout(function () {
            button.classList.remove(ADDED_CLASS);
          }, 600);
        }
      })
      .catch(function () {
        // Graceful degradation: let the browser submit the form normally.
        form.submit();
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  });
})();
